import { LocalizationProvider, DesktopTimePicker } from '@mui/lab'
import AdapterMoment from '@mui/lab/AdapterMoment'
import { Col, Span } from 'components'
import moment, { Moment } from 'moment'
import 'moment/locale/pt-br'
import { Controller } from 'react-hook-form'
import { COLORS, SPACING } from 'utils'

import {
  InputLabelCustom,
  ITextField,
  TextFieldStyled,
  TextFieldContainer,
  CalendarButton
} from './TimePicker.styles'

moment.locale('pt-br')

export interface TimePickerProps extends ITextField {
  control?: any
  formValue?: string
  value?: Date | string | null | Moment
  onChange?: (_event: any) => void
  label?: string
  placeholder?: string
  defaultValue?: Date | string
  disabled?: boolean
  errors?: any
  onBlur?: any
  customError?: any
  allowTyping?: boolean
}

const TimePicker: React.FC<TimePickerProps> = ({
  value,
  onChange,
  label = '',
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  control,
  formValue,
  placeholder,
  width,
  defaultValue,
  disabled,
  errors,
  onBlur,
  customError,
  allowTyping = false
}) => {
  // const hasError = errors && errors[formValue]
  const hasError = (errors && errors[formValue]) || customError

  const getTimePicker = (value: any, onChange: any) => {
    return (
      <DesktopTimePicker
        value={value}
        disabled={disabled}
        onChange={onChange}
        renderInput={({ inputProps, InputProps, ...rest }) => (
          <TextFieldContainer>
            {!allowTyping && (
              <CalendarButton>{InputProps.endAdornment}</CalendarButton>
            )}
            <TextFieldStyled
              allowTyping={allowTyping}
              hasError={hasError}
              onFocus={(e) => (!allowTyping ? e.target.blur() : null)}
              onBlur={onBlur}
              inputProps={{
                ...inputProps,
                ...getPropIfExists('placeholder', placeholder)
              }}
              variant="standard"
              width={width}
              InputProps={{
                ...InputProps,
                ...(!allowTyping && { endAdornment: null })
              }}
              {...rest}
            />
          </TextFieldContainer>
        )}
      />
    )
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} locale="pt-br">
      <Col
        marginTop={marginTop}
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        marginRight={marginRight}
      >
        <InputLabelCustom hasError={hasError}>{label}</InputLabelCustom>
        {control ? (
          <Controller
            control={control}
            name={formValue}
            defaultValue={defaultValue}
            render={({ field: { value, onChange } }) => (
              <>
                {getTimePicker(value, onChange)}
                {hasError && (
                  <Span
                    text={errors[formValue]?.message || 'Erro.'}
                    color={COLORS.error}
                    marginTop={SPACING.spacing5}
                  />
                )}
              </>
            )}
          />
        ) : (
          <>
            {getTimePicker(value, onChange)}
            {hasError && (
              <Span
                text={hasError?.message || 'Erro.'}
                color={COLORS.error}
                marginTop={SPACING.spacing5}
              />
            )}
          </>
        )}
      </Col>
    </LocalizationProvider>
  )
}

const getPropIfExists = (name: string, value: any) =>
  value ? { [name]: value } : {}

export default TimePicker
